var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  clipRule: "evenodd",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 1,
  viewBox: "0 0 32 40",
  xmlSpace: "preserve",
  x: "0px",
  y: "0px"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "m3.9902 9.9902a1.0001 1.0001 0 0 0 -0.69727 1.7168l12 12a1.0001 1.0001 0 0 0 1.4141 0l12-12a1.0001 1.0001 0 1 0 -1.4141 -1.4141l-11.293 11.293-11.293-11.293a1.0001 1.0001 0 0 0 -0.7168 -0.30273z",
  clipRule: "nonzero",
  color: "#000000",
  colorRendering: "auto",
  dominantBaseline: "auto",
  fillRule: "nonzero",
  imageRendering: "auto",
  shapeRendering: "auto",
  solidcolor: "#000000",
  style: {
    fontFeatureSettings: "normal",
    fontVariantAlternates: "normal",
    fontVariantCaps: "normal",
    fontVariantLigatures: "normal",
    fontVariantNumeric: "normal",
    fontVariantPosition: "normal",
    isolation: "auto",
    mixBlendMode: "normal",
    shapePadding: 0,
    textDecorationColor: "#000000",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textIndent: 0,
    textOrientation: "mixed",
    textTransform: "none",
    whiteSpace: "normal"
  }
}));
export default SvgChevronDown;